<script lang="ts">
    import { LANGUAGES, getUserLanguage, setUserLanguage } from "@/utils/lang";

    import { onMount } from "svelte";

    // Nuevas props
    let { label = "", onLanguageChange } = $props();

    let showLangs = $state(false);
    let current = $state(LANGUAGES[0]);

    onMount(() => {
        const userLang = getUserLanguage();
        const found = LANGUAGES.find((l) => l.code === userLang);
        if (found) {
            current = found;
        }
        // console.log("LanguageSelector mounted:", current);
    });

    function toggleLangs() {
        showLangs = !showLangs;
    }

    function changeLanguage(lang) {
        // console.log("Changing language to:", lang);
        current = lang;
        setUserLanguage(lang.code);
        showLangs = false;

        // Notificar al padre
        onLanguageChange(lang.code);
    }
</script>

<div class="langSelector">
    {#if label}
        <label>{label}</label>
    {/if}

    <div class="langSelector__select" on:click={toggleLangs}>
        <div>
            <span style="background-image: url({current.flag})"></span>
            <p>{current.label}</p>
        </div>
        <i
            class="fal"
            class:fa-chevron-up={showLangs}
            class:fa-chevron-down={!showLangs}
        ></i>
    </div>

    {#if showLangs}
        <ul class="langSelector__langs">
            {#each LANGUAGES as lang}
                <li on:click={() => changeLanguage(lang)}>
                    <img src={lang.flag} alt={lang.label} />
                    {lang.label}
                </li>
            {/each}
        </ul>
        <div class="langSelector__foreground" on:click={toggleLangs}></div>
    {/if}
</div>

<style lang="scss">
    @use "./styles/index.scss";
</style>
